<template>
  <section v-if="linked" class="wechat-account">
    <p>{{ t('account-wechat') }}: {{ t('account-wechat-linked') }}</p>
  </section>
</template>

<script>
import api from '@/api/api';
import { t } from '@/texts';

export default {
  name: 'WeChatAccountSection',
  data() {
    return { linked: false };
  },
  async created() {
    const u = this.$store.state.user;
    if (!u) return;
    try {
      const list = await api._rest.get_ex('wechat/identities', { params: { user: u.id } });
      this.linked = list.length > 0;
    } catch (e) {
      // nothing to show
    }
  },
  methods: { t },
};
</script>
